import type {
	ValidateBatchProductsRequestDto,
	ValidateBatchProductsResponseDto,
	ProductDto,
	ValidateConfigurationResponseDto,
	ValidateConfigurationRequestDto,
} from "../types/validation";

const API_BASE_URL = "/configure/api/validation";

export async function validateConfiguration(
	products: ProductDto[]
): Promise<ValidateConfigurationResponseDto> {
	const request: ValidateConfigurationRequestDto = {
		products: products.map((p) => ({ id: p.id })),
	};

	const response = await fetch(`${API_BASE_URL}/configuration`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Validation failed: ${response.statusText}`);
	}

	return response.json();
}

export async function validateBatchProducts(
	baseConfiguration: ProductDto[],
	productsToValidate: ProductDto[],
	productIdToReplace?: string | null
): Promise<ValidateBatchProductsResponseDto> {
	const request: ValidateBatchProductsRequestDto = {
		baseConfiguration: baseConfiguration.map((p) => ({ id: p.id })),
		productsToValidate: productsToValidate.map((p) => ({ id: p.id })),
		productIdToReplace: productIdToReplace ?? null,
	};

	const response = await fetch(`${API_BASE_URL}/batch`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Batch validation failed: ${response.statusText}`);
	}

	return response.json();
}